import { SelectChangeEvent } from "@mui/material";
import { ChangeEvent, useEffect } from "react";
import { useSearchParams } from "react-router-dom";
import { RegistrationRequestIntroductionMethod } from "../../../../api/psc";
import { useRegistrationContext } from "../../context/registrationContext";
import StepOneView from "./StepOneView";

type TProps = {
  handlePostTrueDryRun: () => void;
  inProgress: boolean;
};

export default function StepOneContainer({
  handlePostTrueDryRun,
  inProgress,
}: TProps) {
  const { state, dispatch } = useRegistrationContext();

  const [searchParam, setSearchParam] = useSearchParams();
  useEffect(() => {
    const social = searchParam.get("social");
    if (social) {
      dispatch({
        type: "setIntroductionMethod",
        payload: RegistrationRequestIntroductionMethod.SOCIAL_MEDIA,
      });
      dispatch({
        type: "diactivateSocial",
        payload: true,
      });
    }
  }, []);

  //View State Handlers
  const handleNameChange = (event: ChangeEvent<HTMLInputElement>) => {
    dispatch({ type: "setFullName", payload: event.target.value });
  };
  const handlePhoneNumberChange = (event: ChangeEvent<HTMLInputElement>) => {
    dispatch({ type: "setContactNumber", payload: event.target.value });
  };
  const handleCompanyNameChange = (event: ChangeEvent<HTMLInputElement>) => {
    dispatch({ type: "setCompanyName", payload: event.target.value });
  };
  const handleWorkFieldChange = (event: ChangeEvent<HTMLInputElement>) => {
    dispatch({ type: "setLineOfWork", payload: event.target.value });
  };
  const handleCityChange = (event: ChangeEvent<HTMLInputElement>) => {
    dispatch({ type: "setCity", payload: event.target.value });
  };

  const handleIntroductionMethodChange = (
    event: SelectChangeEvent<RegistrationRequestIntroductionMethod>
  ) => {
    dispatch({
      type: "setIntroductionMethod",
      payload: event.target.value as RegistrationRequestIntroductionMethod,
    });
  };
  // Click Handlers
  const handleButtonClick = () => {
    handlePostTrueDryRun();
  };

  const handleCloseSnackBar = () => {
    dispatch({ type: "clearError" });
  };

  return (
    <StepOneView
      // State
      state={state}
      // View Event
      handleButtonClick={handleButtonClick}
      // State Change Handlers
      handleIntroductionMethodChange={handleIntroductionMethodChange}
      handleNameChange={handleNameChange}
      handleCompanyNameChange={handleCompanyNameChange}
      handlePhoneNumberChange={handlePhoneNumberChange}
      handleWorkFieldChange={handleWorkFieldChange}
      handleCityChange={handleCityChange}
      // Errors and handler
      error={state.error}
      handleCloseSnackBar={handleCloseSnackBar}
      inProgress={inProgress}
    />
  );
}
